let yandexMetrikaInstalled = false;
const YM_COUNTER_ID = 91054466;

interface YMFunction {
  (...args: unknown[]): void;
  a?: unknown[];
}

interface YandexMetrikaWindow extends Window {
  ym?: YMFunction;
}

declare const window: YandexMetrikaWindow;

export const useYandexMetrika = () => {
  const loadScript = (src: string, onload: () => void) => {
    const head = document.head;
    const script = document.createElement('script');

    script.async = true;
    script.src = src;

    head.appendChild(script);

    script.onload = onload;
  };

  const isEnabled = (): boolean => {
    return import.meta.env.PROD && !import.meta.env.VITE_YANDEX_METRIKA_DISABLED;
  };

  const init = () => {
    if (!isEnabled()) {
      return;
    }

    window.ym?.(YM_COUNTER_ID, 'init', {
      defer: true,
      webvisor: true,
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
    });
  };

  const hit = ({ url, referer }: { url: string; referer?: string }) => {
    if (!isEnabled()) {
      return;
    }

    window.ym?.(YM_COUNTER_ID, 'hit', url, { referer });
  };

  const setEmployeeId = (employeeId: string) => {
    if (!isEnabled()) {
      return;
    }

    window.ym?.(YM_COUNTER_ID, 'setEmployeeID', employeeId);
  };

  const setBusinessId = (businessId: string) => {
    if (!isEnabled()) {
      return;
    }

    window.ym?.(YM_COUNTER_ID, 'employeeParams', {
      businessId,
    });
  };

  const goal = (id: string) => {
    if (!isEnabled()) {
      return;
    }

    window.ym?.(YM_COUNTER_ID, 'reachGoal', id);
  };

  if (!yandexMetrikaInstalled && isEnabled()) {
    yandexMetrikaInstalled = true;

    if (!window.ym) {
      const ymFunc: YMFunction = function (...args: unknown[]) {
        ymFunc.a = ymFunc.a || [];
        ymFunc.a.push(args);
      };
      window.ym = ymFunc;
    }

    loadScript('https://mc.yandex.ru/metrika/tag.js', () => {
      init();
    });
  }

  return {
    hit,
    goal,
    setEmployeeId,
    setBusinessId,
  };
};
